import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#132743',
    },
  },
  typography: {
    fontFamily: 'Serif Georgia',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          '.title': {
            color: '#132743',
            marginLeft: '20px',
            marginTop: '4px',
          },
          '.button': {
            left: '84%',
            top: '48px',
            width: '15%',
          },

          '.button1': {
            width: '15%',
            gap: '8px',
            top: '-95px',
            left: '84%',
          },
          '.button2': {
            width: '15%',
            gap: '8px',
            top: '5px',
            left: '84%',
          },
          '.iconEdit': {
            cursor: 'pointer',
            color: '#2c3e50',
            fontSize: '18px',
            marginRight: '5px',
          },
          '.iconlaunch': {
            cursor: 'pointer',
            fontSize: '18px',
            marginRight: '5px',
            color: '#2c3e50',
          },

          '.flex-between-center': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '24px',
          },
          '.paper-flex-column': {
            padding: '16px',
            display: ' flex',
            flexDirection: 'column',
            width: ' 100%',
          },

          '.tool-bar': {
            backgroundColor: '#fbfbfb',
            color: 'rgba(0, 0, 0, 0.87)',
            border: '1px solid rgba(0, 0, 0, 0.06)',
            borderRadius: '2px',
          },
          '.grid-item': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '24px',
          },
          '.buttonAdd' : {
  marginRight: '12px'

},
'.flex-end' :  {
  display: 'flex',
  justifyContent:' end',
} ,
'.textF-style' :{
width: '100%', height: '100%'

},
'.box-details' :{
  borderBottom: 1, 
  borderColor: 'divider'

},

".dataGridCustomStyles" :{
  border: '1px solid #e2e8f4',
  borderRadius: '10px',
  boxShadow: '0 2px 12px rgba(74, 95, 150, 0.06)',

  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#f4f6fb !important',
    borderBottom: '2px solid #e2e8f4 !important',
    borderRadius: '10px 10px 0 0',
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: '#f4f6fb !important',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    backgroundColor: '#f4f6fb !important',
  },
  '& .MuiDataGrid-columnHeader *': {
    transition: 'none !important',
  },
  '& .MuiDataGrid-columnHeader:hover .MuiDataGrid-columnHeaderTitle': {
    color: '#1d3f91 !important',
  },
  '.MuiDataGrid-columnHeaderTitle': {
    fontWeight: '600',
    color: '#2b4f9f',
    fontSize: '11px',
    letterSpacing: '0.07em',
    textTransform: 'uppercase',
    overflow: 'visible !important',
  },
  '& .MuiDataGrid-row': {
    minHeight: '62px !important',
    maxHeight: '62px !important',
  },
  '& .MuiDataGrid-cell': {
    display: 'flex',
    alignItems: 'center',
    minHeight: '62px !important',
    maxHeight: '62px !important',
    overflow: 'hidden',
    borderBottom: '1px solid #f0f2f8',
  },
  '& .MuiDataGrid-scrollbarFiller, & .MuiDataGrid-scrollbarFiller--header': {
    display: 'none',
  },
},
'.hr-style': {

    border: 'none',
    borderBottom: '1px solid rgba(0, 0, 0, 0)',
    margin: '10px 0',


},

'.box-bg'  :{
 
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,

},

'.launchIcon-style' : {

  cursor: 'pointer',
  fontSize: '18px',
  marginRight: '5px',
  color: '#2c3e50',
},
          '.box-style': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',

            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
          },
          '.box-style1': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',

            bgcolor: 'white',
            boxShadow: 24,
            p: 4,
          },
          '.page-content': {
            width: ' 100%',
            padding: '24px 32px',
            borderRadius: '10px',
            border: '1px solid #D3D6DC',
            background: ' #FFFFFF',
          },
          '.div': {
            width: ' 100%',
            padding: '16px 0px 0px 0px',
            gap: '24px',
            borderRadius: '4px 0px 0px 0px',
            marginBottom: '9px',
            border: '1px solid #D3D6DC',
            background: ' #FFFFFF',
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&:before': {
            opacity: 0.5,
            backgroundColor: '#DFE7E8',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          backgroundColor: '#F7FAFA',
          color: '#0B1E2D',
          '&:hover': {
            backgroundColor: '#EAF0F0',
          },
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: '7px',
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '14px',
          padding: '10px 22px',
          lineHeight: 1.4,
          minHeight: '40px',
          whiteSpace: 'nowrap',
        },
        containedPrimary: {
          backgroundColor: '#00146D',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#0a1f8a',
          },
        },
        outlinedPrimary: {
          borderColor: '#0D9B87',
          color: '#076B5C',
          '&:hover': {
            backgroundColor: '#E1F4F0',
            borderColor: '#076B5C',
          },
        },
      },
    },
  },
})
